<script>
export default {
	name: 'DefaultLayout',
	expose: [],
	inheritAttrs: false,
};
</script>


<script setup>
import ExperienceFragment from '~/aem-components/ExperienceFragment.vue';
import BtnBackToTop from '~/components/BtnBackToTop.vue';
import HiddenSeamlessBookingWidget from '~/components/HiddenSeamlessBookingWidget.vue';

</script>


<template>
<div class="DefaultLayout flex flex-col min-h-screen" data-layout="Default">
	<ExperienceFragment
		class="global-mobile-download-app-notification"
		xfPath="/content/experience-fragments/mh/$country/$lang/site/mobile-download-app-notification/master"
	/>
	<div class="sticky-spacer h-$mobileDlAppNotificationHeight"></div>
	
	<ExperienceFragment
		class="global-header-notification"
		xfPath="/content/experience-fragments/mh/$country/$lang/site/header-notification/master"
	/>
	<div class="sticky-spacer h-$headerNotificationHeight"></div>
	
	<ExperienceFragment
		class="global-header"
		xfPath="/content/experience-fragments/mh/$country/$lang/site/header/master"
	/>
	
	<HiddenSeamlessBookingWidget />
	
	<div id="content"></div>
	<div id="booking-subpage-container"></div>
	<main>
		<slot></slot>
	</main>
	
	<div class="floating-bottom-right-container">
		<ExperienceFragment
			class="global-floating-widget"
			xfPath="/content/experience-fragments/mh/$country/$lang/site/floating-widget/master"
		/>
		<BtnBackToTop />
	</div>
	
	<ExperienceFragment
		class="global-cookies-notification"
		xfPath="/content/experience-fragments/mh/$country/$lang/site/cookies-notification/master"
	/>
	<ExperienceFragment
		class="global-footer"
		xfPath="/content/experience-fragments/mh/$country/$lang/site/footer/master"
	/>
</div>
</template>



<style scoped lang="scss">
@use '~/styles/partials/_var.scss';

:slotted(.page) {
	min-height: 400px;
}

</style>
